<input nbInput fullWidth i18n-placeholder="@@SearchPlaceholder"
       placeholder="Поиск товара"
       class="input-base"
       [formControl]="inputFormControl"
       (mousedown)="show()"
       fieldSize="small"
       #autoCompleteInput>

<span class="icon"><a [routerLink]="[]" (click)="onSubmit()"><nb-icon icon="search-outline"></nb-icon></a></span>

<div class="custom-autocomplete" *ngIf="terms?.length">
    <div class="custom-autocomplete__item" *ngFor="let product of terms">
        <div class="auto-item">
            <div class="auto-item__photo auto-item__photo--hide-mobile" (click)="openModalProduct(product)">
                <div class="photo-table">
                    <div class="photo-table__picture cursor-pointer">
                        <img [src]="getImageUri(product.picture)" alt=""/>
                    </div>
                </div>
            </div>

            <div class="auto-item__title" (click)="openModalProduct(product)">
              <div class="article"><app-search-code-highlight [code]="product.productCode" [query]="value"/></div>
              <span class="value cursor-pointer"><app-search-code-highlight field="name" [code]="product.header" [productCode]="product.productCode" [query]="value"/></span>
            </div>

            <div class="auto-item__count auto-item__count--hide-mobile" *ngIf="!isShowcase">
                <app-product-availability [product]="product"/>
            </div>

            <div class="auto-item__price" *ngIf="!isShowcase">
                <app-product-price [product]="product"/>
            </div>

            <div class="auto-item__price" *ngIf="!isShowcase">
                <app-product-price [product]="product" [showVAT]="true"/>
                <span class="nds">с НДС</span>
            </div>

            <div class="auto-item__cart--hide-mobile" *ngIf="!isShowcase && !isSpecification">

              @if (isShowRequestedProducts(product)) {
                <button class="attach-btn" nbButton status="primary" size="small" (click)="openAddToRequestedProducts(product)">
                  <nb-icon icon="attach-outline"/>
                </button>
              } @else {
                <app-add-to-cart [product]="product" [catalog]="true"></app-add-to-cart>
              }

            </div>
        </div>
    </div>
</div>
